import { getWidgetBackgroundProps } from './getWidgetBackgroundProps';
export function getSimilarHotelsDetails(components) {
    const result = {};
    if (!components)
        return result;
    // Iterate over the components
    components.forEach((component) => {
        const { __typename, alias } = component;
        // Handle only GenericComponent with the Specific alias
        if (__typename === 'GenericComponent' && alias === 'similarHotelsWidget') {
            const backgroundDetails = component.backgrounds;
            const backgroundColorCMS = component.backgroundColor;
            result.backgroundColor = backgroundColorCMS || undefined;
            result.backgroundImage = backgroundDetails
                ? getWidgetBackgroundProps(component.backgrounds)
                : undefined;
            component.content.forEach((subComponent) => {
                var _a;
                const { __typename: subType } = subComponent;
                // Set the appropriate subcomponents if found
                if (subType === 'SectionHeading')
                    result.sectionHeading = subComponent;
                if (subType === 'Carousel' && ((_a = subComponent === null || subComponent === void 0 ? void 0 : subComponent.slides) === null || _a === void 0 ? void 0 : _a.length) > 0)
                    result.carousel = subComponent;
            });
        }
    });
    // If no valid Carousel, reset sectionHeading
    if (!result.carousel) {
        result.sectionHeading = undefined;
    }
    return result;
}
